import { FetchModel } from 'src/services'
import { Banner } from 'src/components/ui'
import { ActiveCredits, NEW, NOT_RUNNING } from 'models/model/model.utils'
import {
  activeModelCreditsMessage,
  trainingCreditsMessage,
} from 'models/model.types'

type Props = {
  model: FetchModel
  availableCredits: ActiveCredits
}

export function CreditsBanner({ model, availableCredits }: Props): JSX.Element {
  if (availableCredits.available > 0) return <></>
  if (model.state === NOT_RUNNING && availableCredits.type === 'activeModel') {
    return <Banner variant="warning">{activeModelCreditsMessage}</Banner>
  }

  if (model.state === NEW && availableCredits.type === 'training') {
    return <Banner variant="warning">{trainingCreditsMessage}</Banner>
  }

  return <></>
}
